import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../services/api';

// Drill-down popup shown when a user clicks a "Face Value" cell on the GSEC
// Portfolio Report - shows the Sell history against that Buy deal, so the
// user can see exactly how today's remaining face value was reached from the
// original Buy (e.g. 250,000,000 original - 50,000,000 sold - 200,000,000
// sold = 0 remaining).
export default function PrimaryDealsModal({ row, onClose }) {
  const [history, setHistory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!row) return;
    let isMounted = true;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const buyDealNumber = row.deal_number;
        const params = new URLSearchParams({ buyDealNumber });
        const res = await fetch(`${API_BASE_URL}/isin-master/gsec/sell-history?${params.toString()}`);
        if (!res.ok) throw new Error('Failed to fetch sell history');
        const json = await res.json();
        if (isMounted) setHistory(json.data || null);
      } catch (e) {
        if (isMounted) setError(e.message || 'Error fetching sell history');
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => { isMounted = false; };
  }, [row]);

  if (!row) return null;

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 }}
      onClick={onClose}
    >
      <div
        style={{ background: '#fff', borderRadius: 8, width: '90vw', maxWidth: 800, maxHeight: '80vh', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 30px rgba(0,0,0,0.25)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: 16 }}>Sell History - {row.deal_number} ({row.isin})</h3>
          <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>&times;</button>
        </div>
        <div style={{ padding: 16, overflowY: 'auto' }}>
          {loading && <div>Loading...</div>}
          {error && <div style={{ color: '#dc2626' }}>{error}</div>}
          {!loading && !error && history && (
            <>
              <div style={{ marginBottom: 12, fontSize: 14 }}>
                Original Face Value: <strong>{Number(history.originalFaceValue || 0).toLocaleString()}</strong>
                {' '}&nbsp;|&nbsp; Remaining Today: <strong>{Number(history.remainingFaceValue || 0).toLocaleString()}</strong>
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ background: '#f3f4f6' }}>
                    <th style={{ textAlign: 'left', padding: 8 }}>Sell Deal Number</th>
                    <th style={{ textAlign: 'left', padding: 8 }}>Value Date</th>
                    <th style={{ textAlign: 'right', padding: 8 }}>Face Value Sold</th>
                    <th style={{ textAlign: 'right', padding: 8 }}>Remaining After</th>
                    <th style={{ textAlign: 'left', padding: 8 }}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {history.sells.length === 0 ? (
                    <tr><td colSpan={5} style={{ textAlign: 'center', padding: 16, color: '#6b7280' }}>No sells have been made against this deal - full face value still held.</td></tr>
                  ) : history.sells.map((s) => (
                    <tr key={s.deal_number} style={{ borderBottom: '1px solid #f3f4f6' }}>
                      <td style={{ padding: 8 }}>{s.deal_number}</td>
                      <td style={{ padding: 8 }}>{s.value_date ? String(s.value_date).split('T')[0] : ''}</td>
                      <td style={{ padding: 8, textAlign: 'right' }}>{Number(s.face_value_sold || 0).toLocaleString()}</td>
                      <td style={{ padding: 8, textAlign: 'right' }}>{Number(s.remaining_after || 0).toLocaleString()}</td>
                      <td style={{ padding: 8 }}>{s.status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
